/* NOIRFORM collection + search: AJAX filtering, sorting, pagination and grid density. */
(function () {
  'use strict';

  var NF = (window.NF = window.NF || {});
  var STORAGE_KEY = 'noirform:grid';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function debounce(fn, wait) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); }; }

  function readDensity() {
    try { return window.localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }
  function saveDensity(v) {
    try { window.localStorage.setItem(STORAGE_KEY, v); } catch (e) { /* storage blocked */ }
  }

  function Collection(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    this.form = qs('[data-facets-form]', root);
    this.controller = null;
    this.density = readDensity() || '4';

    this.applyDensity(this.density);
    this.bindDensity();
    if (this.form) this.bindFacets();
    this.bindLinks();
  }

  /* ----- density ----- */
  Collection.prototype.applyDensity = function (value) {
    this.density = value;
    qsa('[data-product-grid]', this.root).forEach(function (g) { g.setAttribute('data-columns', value); });
    qsa('[data-grid-toggle]', this.root).forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-grid-toggle') === value ? 'true' : 'false');
    });
  };
  Collection.prototype.bindDensity = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-grid-toggle]');
      if (!btn) return;
      var v = btn.getAttribute('data-grid-toggle');
      saveDensity(v);
      self.applyDensity(v);
    });
  };

  /* ----- fetching ----- */
  Collection.prototype.buildUrl = function () {
    var params = new URLSearchParams();
    new FormData(this.form).forEach(function (value, key) {
      if (value !== '' && value !== null) params.append(key, value);
    });
    var action = this.form.getAttribute('action') || window.location.pathname;
    var qsString = params.toString();
    return action + (qsString ? '?' + qsString : '');
  };

  Collection.prototype.update = function (url, push) {
    var self = this;
    var results = qs('[data-collection-results]', this.root);
    if (results) results.classList.add('is-loading');
    if (this.controller && this.controller.abort) this.controller.abort();
    this.controller = 'AbortController' in window ? new AbortController() : null;

    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(this.sectionId);
    return fetch(fetchUrl, this.controller ? { signal: this.controller.signal } : undefined)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // remember which facet groups are open
        var openIdx = qsa('.facet', self.root).map(function (d) { return d.open; });

        ['[data-collection-results]', '[data-active-filters]', '[data-facets-panels]', '[data-facets-count]', '.page-head__text'].forEach(function (sel) {
          var fresh = qs(sel, doc), cur = qs(sel, self.root);
          if (fresh && cur) cur.replaceWith(fresh);
          else if (!fresh && cur && sel === '[data-active-filters]') cur.remove();
        });
        // active filter chips may not exist yet on the page
        var freshChips = qs('[data-active-filters]', doc);
        if (freshChips && !qs('[data-active-filters]', self.root)) {
          var res = qs('[data-collection-results]', self.root);
          if (res) res.parentNode.insertBefore(freshChips, res);
        }
        var freshClear = qs('.facets__clear', doc), curClear = qs('.facets__clear', self.root);
        if (freshClear && curClear) curClear.setAttribute('href', freshClear.getAttribute('href'));

        qsa('.facet', self.root).forEach(function (d, i) { if (openIdx[i] !== undefined) d.open = openIdx[i]; });
        self.applyDensity(self.density);

        if (push !== false) window.history.pushState({ nf: true }, '', url);
        document.dispatchEvent(new CustomEvent('nf:collection:updated'));
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = url; // graceful fallback to a full page load
      });
  };

  /* ----- facets ----- */
  Collection.prototype.bindFacets = function () {
    var self = this;
    var run = debounce(function () { self.update(self.buildUrl()); }, 250);

    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.update(self.buildUrl());
      // on small screens close the drawer after Apply
      var drawer = e.target.closest('[data-drawer]') || qs('.facets-drawer', self.form);
      if (drawer && drawer.classList.contains('is-open') && NF.drawer && e.submitter) NF.drawer.close(drawer);
    });
    this.form.addEventListener('change', function (e) {
      if (e.target.matches('.check__input, .facet__price input, select[name="sort_by"]')) run();
    });
  };

  /* ----- chips, clear links, pagination ----- */
  Collection.prototype.bindLinks = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      var a = e.target.closest('.active-filters a, .facets__clear, .pagination a');
      if (!a || !a.getAttribute('href')) return;
      e.preventDefault();
      var isPage = !!a.closest('.pagination');
      self.update(a.getAttribute('href')).then(function () {
        if (isPage) {
          var top = qs('.toolbar', self.root) || self.root;
          top.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        // keep form inputs in sync after chip removal
        if (!isPage && self.form) {
          var drawer = qs('.facets-drawer', self.root);
          if (drawer && a.classList.contains('facets__clear') && NF.drawer) NF.drawer.close(drawer);
        }
      });
    });
    window.addEventListener('popstate', function () {
      self.update(window.location.pathname + window.location.search, false);
    });
  };

  function init(root) {
    qsa('[data-collection]', root).forEach(function (el) {
      if (!el.__nfCollection) el.__nfCollection = new Collection(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
